import React from 'react'
import PropTypes from 'prop-types'

import CrosshairIcon from '../../../../assets/svg/CrosshairIcon'
import styles from '../HistoricalImagery.module.scss'

function ImageryCaptureDate(props) {
  return (
    <div className={styles.captureDateContainer}>
      <CrosshairIcon />
      <div className={styles.captureDateText}>
        <h6>Date:</h6>
        <p>{props.date || 'Not Available at this time'}</p>
      </div>
    </div>
  )
}

ImageryCaptureDate.propTypes = {
  date: PropTypes.string
}

export default ImageryCaptureDate
